/* Необходимо для корректной динамической подгрузки скриптов */
__webpack_public_path__ = window.resourceBaseUrl;